// src/services/edefterApi.js
// Centralized client for the edefter backend (srv.dpg.net.tr/edefter).
//
// The edefter service gained Spring Security (it used to be open), so every
// call now needs the Core-issued Bearer token. These helpers attach it from
// the same place the rest of the app reads it (AuthService.getAuthToken), so
// edefter calls authenticate exactly like the DpgFinance API calls do.

import AuthService from './authService';

export const EDEFTER_BASE =
  window.APP_CONFIG?.edefterApiUrl || 'https://srv.dpg.net.tr/edefter';

/**
 * Bearer auth header for the current user, or {} when not logged in.
 * Use for XMLHttpRequest uploads where edefterFetch can't be used.
 * @returns {Record<string, string>}
 */
export const edefterAuthHeaders = () => {
  const token = AuthService.getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Drop-in replacement for fetch() that attaches the current Bearer token to
 * edefter backend calls. An explicit Authorization in options.headers wins.
 * @param {string} url
 * @param {RequestInit} [options]
 * @returns {Promise<Response>}
 */
export const edefterFetch = (url, options = {}) => {
  const headers = { ...(options.headers || {}) };
  if (!headers.Authorization && !headers.authorization) {
    Object.assign(headers, edefterAuthHeaders());
  }
  return fetch(url, { ...options, headers });
};
